<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 195px;
  margin-top: 20px;

  .plane {
    // padding-top: 5px;

    .account {
      margin-top: 20px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      .account_data{
        height: 79px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 18px;
        p:nth-child(2){
          font-family: 'dina';
          font-size: 36px;
          span {
            font-size: 36px;
            font-family: "dina";
            color: rgba(255, 255, 255, 0.7);
          }
        }
      }
      .data2{
        align-items: flex-end;
      }
    }

    .progress{
      width: 376px;
      padding:20px;
    }
  }

}
</style>

<template>
  <div class="camera">
    <custom-plane title="物管台账" class="plane"
      :iconImg="require('@/assets/compImg/icon/Account.png')">
      <div class="account">
        <div class="account_data">
          <p>已缴费商户</p>
          <p>{{account.split('/')[0]}}<span>&nbsp;/&nbsp;</span><span>{{account.split('/')[1]}}</span></p>
        </div>
        <div class="account_data data2">
          <p>已缴金额</p>
          <p>{{money}}</p>
        </div>
      </div>
      <div class="progress">
        <custom-progress-heightline
            :value="50"
            :splitCount="40"
          ></custom-progress-heightline>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props:{
    account:String,
    money:String
  }
}
</script>
